package com.fireavert.events.mark_as_test.client.presentation

class MarkAsTestDialogController(private val interactor: MarkAsTest) {
    fun onLoad(eventId: Long) = interactor.markEventAsTest(eventId)
    fun close(propertyId: Int) = interactor.close(propertyId)
}